<template>
  <div class="news">
    <banner title="新闻资讯" />
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <div class="content-nav">
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 1}"
            @click="newstype = 1"
          >
            <span>公司新闻</span>
          </div>
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 2}"
            @click="newstype = 2 "
          >
            <span>行业动态</span>
          </div>
        </div>

        <div class="content-nav-item">
          <div class="item-list" v-for="(item,index) in newsList" :key="index">
            <div class="item-img" v-lazy:background-image="item.Img"></div>

            <p class="item-list-title">{{item.Title}}</p>
            <p class="item-list-content">{{item.Content}}</p>
<!--            <div class="item-list-more">-->
<!--              <router-link-->
<!--                class="text-decoration"-->
<!--                :to="{ name: 'newsdetails', params: { id: item.Id }}"-->
<!--              >-->
<!--                <img src="../assets/img/sanjiao.png" />-->
<!--                <span>more</span>-->
<!--              </router-link>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "news",
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      newsList: [],
      newstype: 1
    };
  },
  methods: {
    loadData() {
      let data = [
        {
          "Id": 13,
          "Title": "创菲凡 一起燃 | 2023年BFB集团“双十一”盛势启动！",
          "Img": "img1.png",
          "Type": 1,
          "Content": "10月31日下午2点，BFB集团（杭州）双十一启动会在员工代表苑佳慧的主持下正式开始。大会现场音乐激昂，掌声雷动，热烈的氛围无不昭示着BFB人蓄势待发的斗志和征战双十一的决心！",
          "CreateTime": "2023-11-01T16:24:11.633"
        },
        {
          "Id": 14,
          "Title": "齐奋战，赢胜利丨2023年10月启动大会圆满结束！",
          "Img": "img2.png",
          "Type": 1,
          "Content": "金秋十月，是一个收获的季节，在这个时节我们收获成果、收获希望。同时，我们也迎来了一月一度的十月启动大会，在这里，我们表彰过去，播种未来，带着自己的使命和目标，厉兵秣马，奋勇前行。",
          "CreateTime": "2023-10-27T16:24:11.633"
        },
        {
          "Id": 15,
          "Title": "多燕瘦荣获“2021年度•行业质量标杆企业”和“2021年度•诚信典范企业”两项大奖",
          "Img": "news1.jpg",
          "Type": 1,
          "Content": "2022年1月19日，消费质量报全媒体平台发布了第十一届质量榜样·2021年度传媒大奖榜单，多燕瘦国际控股有限公司不负众望，以品质和信誉喜提“2021年度•行业质量标杆企业”和“2021年度•诚信典范企业”两项大奖，受到各界高度关注。",
          "CreateTime": "2018-07-23T16:24:11.633"
        },
        {
          "Id": 16,
          "Title": "BFB | 品牌多燕瘦出席FFNS2022未来营养素峰会！",
          "Img": "news2.jpg",
          "Type": 2,
          "Content": "由植提桥主办的FFNS2022未来营养素峰会在海南举行，本次峰会以“资源挖掘·技术创新”为题，聚焦当前天然健康原料产业热点议题。大会为期两天，共设8场主题论坛。多燕瘦作为嘉宾出席了本次会议，并为此次会议中的获奖企业颁奖。",
          "CreateTime": "2022-07-09 15:30"
        }
      ]
      this.newsList = data.filter(v=>{
        return v.Type == this.newstype
      })
      this.loading = false;
      // return;
      // this.loading = true;
      // this.$http
      //   .get(`News?type=${this.newstype}&num=6`)
      //   .then(response => {
      //     //console.log(response);
      //     this.newsList = response.data;
      //     this.loading = false;
      //     //window.console.log(this.newsList);
      //   })
      //   .catch(function(error) {
      //     window.console.log(error);
      //   });
    }
  },
  mounted() {
    this.loadData();
  },
  watch: {
    newstype(type) {
      window.console.log(type);
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.news {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      width: 1240px;
      //height: 1600px;
      margin: 0 auto;
      background-color: #fff;
      border: 1px solid red;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid red;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
          width: 330px;
          height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px;
          border: 1px solid #15669e;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 300px;
            height: 210px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 273px;
            height: 100px;
            font-size: 14px;
            color: gray;

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}
</style>
